import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentAuthorizationForBankAccountInquiry from '../document/DocumentAuthorizationForBankAccountInquiry';


function AuthorizationForBankAccountInquiry() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="authorization-for-bank-account-inquiry" parent="5" />
            <HeaderMain slug="authorization-for-bank-account-inquiry" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentAuthorizationForBankAccountInquiry
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default AuthorizationForBankAccountInquiry;